import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { type PropType, computed } from "vue";
import productGallery from "../../frontend-productgallery/ProductGallery.vue";
import labels from "../../shared/labels";
import { type AuctionProduct } from "./types";
import { getBreakpointObservable } from "../../../../shared/breakpoint-observable";


export default /*@__PURE__*/_defineComponent({
  __name: 'related-products',
  props: {
    product: {
        type: Object as PropType<AuctionProduct>,
        required: true,
    },
},
  setup(__props) {



const breakpointObserver = getBreakpointObservable();

const currentBreakpoint = computed(() => {
    return breakpointObserver.currentBreakpoint;
});
const productsPerRow = computed(() => {
    if (currentBreakpoint.value?.up("lg") == true) return 5;
    return 2;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (
                __props.product.relatedProductsUrl != null &&
                __props.product.relatedProductsUrl != ''
            )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(productGallery, {
            "products-per-row": productsPerRow.value,
            "fetch-url": __props.product.relatedProductsUrl
          }, {
            "top-part": _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style['header'])
              }, _toDisplayString(_unref(labels).frontendProductpage.shop
                                .recommendedProductsHeader), 3 /* TEXT, CLASS */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["products-per-row", "fetch-url"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})